import type { FunctionComponent, HTMLAttributes, ReactElement } from 'react';

import { useModifiers } from '../../../styles/hooks/useModifiers';

import styles from './ControlContainer.module.css';

export interface ControlContainerProps extends HTMLAttributes<HTMLDivElement> {
  column?: boolean;
  description?: ReactElement | string;
  label?: ReactElement | string;
  offset?: boolean;
}

export const ControlContainer: FunctionComponent<ControlContainerProps> = ({
  children,
  column,
  description,
  label,
  offset,
  ...rest
}): ReactElement => {
  const mods = useModifiers(styles, 'controlContainer', { column, offset }, { withBaseClass: true });

  return (
    <div className={mods} {...rest}>
      <div className={styles.controlContainer__content}>
        <div className={styles.controlContainer__label}>{label}</div>
        {description ? <div className={styles.controlContainer__description}>{description}</div> : null}
      </div>
      <div className={styles.controlContainer__control}>{children}</div>
    </div>
  );
};
